import React from 'react'
import { useCallbackRef } from './useCallbackRef'

/**
 * React hook that provides a declarative `setTimeout`
 *
 * @param callback the callback to run after specified delay
 * @param delay the delay (in ms)
 */
export function useTimeout(callback, delay) {
  const fn = useCallbackRef(callback)

  React.useEffect(() => {
    if (delay == null) return undefined

    let timeoutId = null

    timeoutId = setTimeout(() => {
      fn()
    }, delay)

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [delay, fn])
}
